var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288,32c0-17.7-14.3-32-32-32s-32,14.3-32,32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3,0s-12.5,32.8,0,45.3 l128,128c12.5,12.5,32.8,12.5,45.3,0l128-128c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0L288,274.7V32z M64,352 c-35.3,0-64,28.7-64,64v32c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3,45.3 c-25,25-65.5,25-90.5,0L165.5,352H64z M432,408c13.3,0,24,10.7,24,24s-10.7,24-24,24s-24-10.7-24-24S418.7,408,432,408z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSolid);
export default __webpack_public_path__ + "static/media/download-solid.85838443d1d598fa103a3927246ac68c.svg";
export { ForwardRef as ReactComponent };